import actionCreator from '@/helpers/redux/actionCreator';

export const NOTIFICATION_OPEN = '@/NOTIFICATION_OPEN';
export const NOTIFICATION_CLOSE = '@/NOTIFICATION_CLOSE';
export const notificationOpen = () => actionCreator(NOTIFICATION_OPEN);
export const notificationClose = () => actionCreator(NOTIFICATION_CLOSE);
